import type SVGType from 'types/svg.types';

const FileUploadIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9994 6.33334H10.3327C8.85992 6.33334 7.66602 7.52725 7.66602 9.00001V23C7.66602 24.4728 8.85992 25.6667 10.3327 25.6667H10.9993M16.9994 6.33334V11C16.9994 12.4728 18.1933 13.6667 19.666 13.6667H24.3327M16.9994 6.33334L24.3327 13.6667M24.3327 13.6667V23C24.3327 24.4728 23.1388 25.6667 21.666 25.6667H20.9994"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M16 25.6667V18.3333M16 18.3333L13 21.6667M16 18.3333L19 21.6667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);

export default FileUploadIcon;
